<template>
  <div class="d-flex align-center column-gap-2 cursor-move">
    <app-material-icon name="open_with" />

    <div class="step-card">
      <span class="text-text-secondary">{{ index }} {{ title }}</span>

      <app-button
        v-if="removable"
        type="icon"
        size="small"
        class="ml-4"
        :disabled="signatureGroupsEditionPending"
        @click="onDelete"
      >
        <app-material-icon name="close" />
      </app-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'SigningChecklistStepToOrder',
  emits: ['delete'],
  props: {
    title: {
      type: String,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('signingChecklistOrder', ['signatureGroupsEditionPending']),
  },
  methods: {
    onDelete () {
      this.$emit('delete')
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.step-card {
  height: 52px;
  border: get-border($width: 'border-width-2');
  @include border-radius('border-radius-3');
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
}
</style>
